import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import isEqual from 'lodash.isequal';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Loader } from '@/js/libs/ui/src/V2';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { Item, Wrapper } from './styled';
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/naming-convention
function _SegmentedControl(props, ref) {
    const { options, selectedValue, onChange, disabled: allDisabled, isLoading, formatOptionLabel, dataTestId, numberOfColumns } = props;
    const handleChange = useCallbackRef((value) => () => onChange(value));
    // eslint-disable-next-line no-restricted-syntax
    const getItemProps = React.useCallback(({ value, disabled }) => ({
        checked: isEqual(value, selectedValue),
        disabled: allDisabled || disabled,
        onClick: disabled ? undefined : handleChange(value),
        tabIndex: 0,
    }), [selectedValue, allDisabled, handleChange]);
    return (_jsx(Wrapper, { tabIndex: 0, ref: ref, "data-testid": dataTestId, numberOfColumns: numberOfColumns ?? options.length, children: isLoading ? (_jsx(Loader, {})) : (options.map((option) => {
            const itemProps = getItemProps(option);
            return (_jsx(Item, { ...getItemProps(option), "data-testid": getDataTestId(option.label, `${option.value}${itemProps.checked ? '-selected' : ''}`), children: formatOptionLabel ? formatOptionLabel(option) : option.label }, option.label));
        })) }));
}
export const SegmentedControl = React.forwardRef(_SegmentedControl);
